import { render, staticRenderFns } from "./DeliveryAddressPicker.vue?vue&type=template&id=5c07416e"
import script from "./DeliveryAddressPicker.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports